// extracted by mini-css-extract-plugin
export default {"modalTitle":"modal_styles_modalTitle__FFynC","closeIcon":"modal_styles_closeIcon__N8dP+"};